'use client'

import { useEffect } from 'react'

/** Adds a css class to the body, removes it when the component is destroyed.
 * Useful to change the background color */
export function useBodyCss(className: string) {
  useEffect(() => {
    if (document.body.classList.contains(className)) return
    document.body.classList.add(className)
    return () => {
      document.body.classList.remove(className)
    }
  })
}
